import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EntryIcon } from "../../../ui/icons/entryIcon"
import { AssignmentStateOptions, optionsFormatter } from "../../../utils"
import { resetUpdateProforma } from "../../incarichi/inspectionVisit/edit/gestioneRimborsi/slice"
import { setAssignmentSelected } from "../../incarichi/slice"


export function AssignmentsListPc() {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const PersonaleContabile = useAppSelector(state => state.PersonaleContabile)
    const [showEditAssignment, setShowEditAssignment] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const reimbursement = useAppSelector(state => state.reimbursement)

    useEffect(() => {
        if (reimbursement.updateProformaRequestStatus === 'successfully') {
            setShowEditAssignment(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500)
            dispatch(resetUpdateProforma())
        }
    }, [reimbursement.updateProformaRequestStatus])

    return (
        <div className="p-6">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tl-xl">Operazioni</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Ispettore</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Riferimento</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Contratto</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Anno</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Stato</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignmentState.getAllAssignmentResponse?.data.map((ass, rowIndex) => (
                            <tr
                                key={ass.id}
                                className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                            >
                                <td className="px-3 py-2 text-center">
                                    <div className="flex items-center justify-center gap-2">
                                        <button
                                            onClick={() => {
                                                dispatch(setAssignmentSelected(ass.id))
                                                navigate('/dettaglioPersonaleContabile')
                                                // dispatch(setIncProformaToView('80'))
                                            }}
                                            className="tooltip-container p-1 rounded hover:bg-neutral-100 transition-colors"
                                        >
                                            <EntryIcon color={"orange"} size={28} />
                                            <span className="tooltip-text">Apri Incarico</span>
                                        </button>
                                    </div>
                                </td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.inspectorCode}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.reference}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.departureProtocolInfo}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.personalManagementInfo}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{ass.year}</td>
                                <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                    {optionsFormatter(ass.state, AssignmentStateOptions)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}